module.exports = __webpack_public_path__ + "static/media/kishoriB2.6038943e.png";